<template lang="html">
  <boxwrap class="admin-list--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <button
          class="btn--create"
          title="생성"
        >
          <label>
            <input
              type="file"
              style="display: none;"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="handleSelectFile"
            >
            select file
          </label>
        </button>

        <button
          v-if="agentList.length"
          :disabled="isDataLoading"
          class="btn--modify"
          @click="importCSV"
        >
          <label>
            import
          </label>
        </button>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="{ 'data-loading': showDataLoading }"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      />

      <tbl
        :scrollable="true"
        v-else
      >
       <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="no">
                no
              </tbl-td>

              <tbl-td name="created_at">
                created
              </tbl-td>

              <tbl-td name="login_id">
                login id
              </tbl-td>

              <tbl-td name="login_name">
                login name
              </tbl-td>

              <tbl-td name="level">
                level
              </tbl-td>

              <tbl-td name="status">
                status
              </tbl-td>

              <tbl-td name="updated_at">
                updated
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(agentValue, agentKey) in agentList"
              :key="agentKey"
            >
              <tbl-td name="no">
                {{ agentValue.id }}
              </tbl-td>

              <tbl-td name="created_at">
                {{ agentValue.created_at }}
              </tbl-td>

              <tbl-td name="login_id">
                {{ agentValue.login_id }}
              </tbl-td>

              <tbl-td name="login_name">
                {{ agentValue.login_name }}
              </tbl-td>

              <tbl-td name="level">
                {{ agentValue.level_id }}
              </tbl-td>

              <tbl-td name="status">
                {{ agentValue.status }}
              </tbl-td>

              <tbl-td name="updated_at">
                {{ agentValue.updated_at || '-' }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <!-- <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          /> -->
        </tbl-footer>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
// components
import CheckDataList from '@/components/base/CheckDataList'

// mixins
import { swal } from '@/assets/js/mixins/base/Swal'

// lib
import xlsx from 'xlsx'
import _get from 'lodash/get'
import _head from 'lodash/head'

export default {
  name: 'Import',

  data () {
    return {
      isDataLoading: true,
      isEmpty: true,
      showDataLoading: true,

      agentList: []
    }
  },

  components: {
    CheckDataList
  },

  mixins: [
    swal
  ],

  methods: {
    handleSelectFile (xml) {
      this.isDataLoading = true
      this.showDataLoading = true
      this.isEmpty = false

      const file = _head(_get(xml, 'target.files'))

      if (!file) {
        this.isDataLoading = false
        this.showDataLoading = false
        this.isEmpty = true
        return console.warn('No selected file.')
      }

      const reader = new FileReader()
      reader.onload = async e => {
        const data = e.target.result
        const workbook = xlsx.read(data, { type: 'binary' })
        const wsname = _head(workbook.SheetNames)
        const worksheet = workbook.Sheets[wsname]
        const json = xlsx.utils.sheet_to_json(worksheet, { header: 2 })

        for (let i = 0; i < json.length; i++) {
          this.agentList.push(json[i])
        }
      }

      reader.readAsBinaryString(file)
      xml.target.value = []

      this.isDataLoading = false
      this.isEmpty = false
      this.showDataLoading = false
    },

    importCSV () {
      const success = () => {
        alert('Congrats, you imported all docs!')
      }

      this.$alert('prompt', 'are you sure do want to import this?', {}, { success }, 'question')
    }
  }
}
</script>
